import { connect } from '@lumapps/redux/react';

import {
    programSelectionModalProgramIdsByNameSelector,
    programSelectionModalStatusSelector,
} from '../../ducks/ProgramSelectionModal/selector';
import { fetchProgramsByIds } from '../../ducks/ProgramSelectionModal/thunks';
import { ProgramSelectionModal } from './ProgramSelectionModal';

const mapStatetoProps = (state: BaseStore) => ({
    programIdsByName: programSelectionModalProgramIdsByNameSelector(state),
    modalStatus: programSelectionModalStatusSelector(state),
});

const mapDispatchToProps = {
    fetchProgramsByIds,
};

const ConnectedProgramSelectionmodal = connect(mapStatetoProps, mapDispatchToProps)(ProgramSelectionModal);

export { ConnectedProgramSelectionmodal as ProgramSelectionModal };
